// Módulo Vuex para gestión de zonas y cálculo de rutas óptimas

import api from '@/api'

// Estado inicial
const state = {
  zones: [],
  loading: false,
  error: null,
  currentRoute: null
}

// Getters
const getters = {
  allZones: state => state.zones,
  loading: state => state.loading,
  error: state => state.error,
  currentRoute: state => state.currentRoute,
  zonesByWarehouse: state => warehouseId => {
    return state.zones.filter(zone => zone.warehouse_id === warehouseId)
  }
}

// Acciones
const actions = {
  // Obtener todas las zonas
  async fetchZones({ commit }) {
    commit('setLoading', true)
    try {
      const response = await api.getZones() // Cambiamos a getZones
      commit('setZones', response.data)
      commit('setError', null)
    } catch (error) {
      console.error('Error al obtener zonas:', error)
      commit('setError', 'Error al cargar las zonas')
    } finally {
      commit('setLoading', false)
    }
  },

  // Obtener zonas por bodega
  async fetchZonesByWarehouse({ commit }, warehouseId) {
    commit('setLoading', true)
    try {
      if (!warehouseId) {
        throw new Error('ID de bodega no proporcionado')
      }
      const response = await api.getWarehouseZones(warehouseId)
      commit('setZones', response.data)
      commit('setError', null)
    } catch (error) {
      console.error('Error al obtener zonas por bodega:', error)
      commit('setError', 'Error al cargar las zonas de la bodega')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },

  // Crear una nueva zona
  async createZone({ commit }, zoneData) {
    commit('setLoading', true)
    try {
      const { warehouse_id, ...zoneDetails } = zoneData
      const response = await api.createZone(warehouse_id, zoneDetails)
      commit('setError', null)
      return response.data
    } catch (error) {
      console.error('Error al crear zona:', error)
      commit('setError', 'Error al crear la zona')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },

  // Actualizar una zona existente
  async updateZone({ commit, dispatch }, zoneData) {
    commit('setLoading', true)
    try {
      console.log(zoneData.id);
      const { id, ...zoneDetails } = zoneData
      const response = await api.updateZone(id, zoneDetails)
      
      // Si tenemos el warehouse_id, recargamos las zonas de esa bodega
      if (zoneData.warehouseId) {
        dispatch('fetchZonesByWarehouse', zoneData.warehouseId)
      } else {
        // Si no, recargamos todas las zonas
        dispatch('fetchZones')
      }
      
      commit('setError', null)
      return response.data
    } catch (error) {
      console.error('Error al actualizar zona:', error)
      commit('setError', 'Error al actualizar la zona')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },

  // Eliminar una zona
  async deleteZone({ commit, dispatch }, { id, warehouseId }) {
    commit('setLoading', true)
    try {
      await api.deleteZone(id)
      
      // Si tenemos el warehouse_id, recargamos las zonas de esa bodega
      if (warehouseId) {
        dispatch('fetchZonesByWarehouse', warehouseId)
      } else {
        // Si no, recargamos todas las zonas
        dispatch('fetchZones')
      }
      
      commit('setError', null)
    } catch (error) {
      console.error('Error al eliminar zona:', error)
      commit('setError', 'Error al eliminar la zona')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },

  // Calcular la ruta más corta entre ubicaciones
  async calculateShortestPath({ commit }, routeData) {
    commit('setLoading', true)
    try {
      const response = await api.calculateShortestPath(routeData)
      commit('setCurrentRoute', response.data)
      commit('setError', null)
      return response.data
    } catch (error) {
      console.error('Error al calcular ruta más corta:', error)
      commit('setError', 'Error al calcular la ruta óptima')
      throw error
    } finally {
      commit('setLoading', false)
    }
  }
}

// Mutaciones
const mutations = {
  setZones(state, zones) {
    state.zones = zones
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setError(state, error) {
    state.error = error
  },
  setCurrentRoute(state, route) {
    state.currentRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
